<ng-container *transloco="let t; prefix: scope">
  <div pFocusTrap class="tabbed-dialog-layout">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="tabbed-dialog-layout">
      <div class="tabbed-dialog-body">
        <p class="mb-6">
          <span class="font-bold">{{ t('company') }}:</span> {{ form.controls.name.value }}
        </p>
        <p class="font-bold">{{ t('accountingMethod') }}</p>
        <div class="mb-6 flex">
          <div *ngFor="let method of accountingMethods" class="flex mr-6">
            <div class="mr-2">
              <p-radioButton
                [inputId]="method.key"
                [value]="method.key"
                name="accountingMethod"
                formControlName="accountingMethod"
                [class]="form.controls.accountingMethod.invalid ? 'ng-invalid ng-dirty' : ''"></p-radioButton>
            </div>
            <div>
              <label [for]="method.key">
                {{ t(method.name) }}
              </label>
            </div>
          </div>
        </div>

        <div class="mb-6">
          <p class="font-bold">{{ t('vatAccountingIntervals') }}</p>
          <div class="flex">
            <div *ngFor="let method of vatAccountingIntervals" class="flex mr-6">
              <div class="mr-2">
                <p-radioButton
                  [inputId]="method.key"
                  [value]="method.key"
                  name="vatAccountingInterval"
                  formControlName="vatAccountingInterval"
                  [class]="form.controls.vatAccountingInterval.invalid ? 'ng-invalid ng-dirty' : ''"></p-radioButton>
              </div>
              <div>
                <label [for]="method.key">
                  {{ t(method.name) }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div formGroupName="financialYear">
          <p class="font-bold">{{ t('financialYear') }}</p>
          <div class="w-full grid grid-cols-2 gap-1">
            <div class="flex items-center">
              <span class="mr-1">{{ t('from') }}:</span>
              <app-calendar
                formControlName="start"
                appendTo="body"
                [defaultDate]="null"
                [invalid]="form.controls.financialYear.controls.start.invalid">
              </app-calendar>
            </div>
            <div class="flex items-center">
              <span class="mr-1">{{ t('to') }}:</span>
              <app-calendar
                formControlName="end"
                appendTo="body"
                [defaultDate]="null"
                [invalid]="form.controls.financialYear.controls.end.invalid">
              </app-calendar>
            </div>
          </div>
          <p class="mt-3 text-bl-red-600" *ngIf="form.hasError('isMonthsBetweenOk')">
            {{ form.getError('isMonthsBetweenOk').message }}
          </p>
        </div>
      </div>
      <div class="tabbed-dialog-actions flex justify-end items-end p-4 bg-bl-grey-100">
        <bl-frontend-button
          (onclick)="close(null)"
          variant="secondary"
          [text]="'shared.cancel' | transloco"></bl-frontend-button>
        <bl-frontend-button
          type="submit"
          [disabled]="!isFormValid"
          [title]="submitTitle"
          [text]="'shared.continue' | transloco"></bl-frontend-button>
      </div>
    </form>
  </div>
</ng-container>
